import { COLLAB_INTEREST, CONTENT_INTEREST, PLATFORMS_KEY, SOCIALS_KEY } from "./generalEnums";
import { BASIC_INFO_KEY, BIO_KEY, PROFILE_PHOTO_KEY } from "./profileSetupEnums";

export const EDIT_PROFILE_FORMS = Object.freeze([
  {
    key: PLATFORMS_KEY,
    label: 'Platforms'
  },
  {
    key: SOCIALS_KEY,
    label: 'Socials'
  },
  {
    key: BIO_KEY,
    label: 'About Me'
  },
  {
    key: COLLAB_INTEREST,
    label: 'Collab Interest'
  },
  {
    key: CONTENT_INTEREST,
    label: 'Content Interest'
  },
  {
    key: BASIC_INFO_KEY,
    label: 'Basic Information'
  },
  {
    key: PROFILE_PHOTO_KEY,
    label: 'Profile'
  },
  // {
  //   key: CONTACT_INFO_KEY,
  //   label: 'Contact Method'
  // },
]);